export default __webpack_public_path__ + "e21a66c8a5d848af05e509fd039e2a50.png";